/**
 *
 * This HOC allows you to pass any number of contexts as props to the wrapped component.
 * Usage: withContext({context1: Context1}, {context2: Context2})(WrappedComponent)
 */

import React from "react"
import consumeContext from "./consumeContext"

const withContext = (...contextApis) => {
  return (ComposedComponent) => {
    return contextApis.reduce(
      consumeContext,
      React.forwardRef(({contextAccumulator: contexts, ...ownProps}, ref) => (
        <ComposedComponent
          {...ownProps}
          {...contexts}
          ref={ref} />
      ))
    )
  }
}

export default withContext
